mutation submitOpenSurveyResponse(
  $openSurveyExternalId: String!
  $openSurveyAccessCode: String
  $clientToken: String!
  $idempotencyKey: String!
  $answers: [OpenSurveyAnswerInput!]!
) {
  submitOpenSurveyResponse(
    openSurveyExternalId: $openSurveyExternalId
    openSurveyAccessCode: $openSurveyAccessCode
    clientToken: $clientToken
    idempotencyKey: $idempotencyKey
    answers: $answers
  ) {
    success
  }
}
